import { render, staticRenderFns } from "./waitConfirmUserPay.vue?vue&type=template&id=6b8c69b8&scoped=true&"
import script from "./waitConfirmUserPay.vue?vue&type=script&lang=js&"
export * from "./waitConfirmUserPay.vue?vue&type=script&lang=js&"
import style0 from "./waitConfirmUserPay.vue?vue&type=style&index=0&id=6b8c69b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c69b8",
  null
  
)

export default component.exports